module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    class: {
      'modal-container  small': !_vm.large,
      'modal-container large': _vm.large
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [(_vm.working) ? _c('spinner', {
      attrs: {
        "size": _vm.spinner_size,
        "line-size": _vm.spinner_line_size,
        "speed": _vm.spinner_speed,
        "spacing": _vm.spinner_spacing,
        "message": _vm.spinner_message,
        "font-size": _vm.spinner_font_size
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.working && !_vm.errorOcurred) ? _c('h1', [_vm._v("Finalizado "), _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("done")])]) : _vm._e(), _vm._v(" "), (!_vm.working && _vm.errorOcurred) ? _c('h1', [_vm._v("Ocurrio un error "), _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("error_outline")])]) : _vm._e(), _vm._v(" "), (!_vm.working && _vm.errorOcurred) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(_vm.error != null) ? _c('span', {
      staticClass: "form-group__message help is-danger"
    }, [_vm._v("\n                  " + _vm._s(_vm.error) + "\n                ")]) : _vm._e()])]) : _vm._e()]
  })], 2), _vm._v(" "), (!_vm.working) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('div', {
      staticClass: "btn-group",
      attrs: {
        "role": "group",
        "aria-label": "Basic example"
      }
    }, [_c('button', {
      staticClass: "spacedBtn btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.closeModal
      }
    }, [_vm._v("Cerrar")])])]
  })], 2) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ea1a40a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utils/LoaderModal.vue
// module id = 240
// module chunks = 3